import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { faqs } from '../../data/salesContent';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-ink-soft px-5 py-20 md:py-28" data-id="element-113" data-mp="uru73bkjzm15">
      <div className="mx-auto max-w-3xl" data-id="element-114" data-mp="718acgg01o6g">
        <SectionHeading title="Preguntas frecuentes" data-id="element-115" data-mp="729kmip6y6n4" />
        <ul className="mt-12 space-y-3" data-id="element-116" data-mp="2254its73dxf">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className={`rounded-2xl border bg-ink transition-colors duration-200 ${isOpen ? 'border-gold/50' : 'border-ink-line'}`} data-id="element-117" data-mp="h0fnb2itngt1" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/50 rounded-2xl" data-id="element-118" data-mp="c2nw6aq03ypw">
                  <span className="text-lg font-semibold text-cream md:text-xl" data-id="element-119" data-mp="mrr911wippwk">{f.q}</span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-120" data-mp="rrn9ir60az7d" />
                </button>
                <AnimatePresence initial={false} data-id="element-121" data-mp="3v6j1mboqikeh">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-122" data-mp="42ufx1cux3fx">
                      <p className="px-6 pb-6 text-lg leading-relaxed text-neutral-400" data-id="element-123" data-mp="3gixyihrv0l6k">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}